<template>
  <div id="app">
	<main-header v-if="showHeader" ></main-header>
    <!-- <transition name="fade" mode="out-in">
		<div :style="{'height':notShowFooter.includes(routePath)?'auto': 'calc(100vh - 15%)','overflow':notShowFooter.includes(routePath)?'inherit': 'hidden'}">
			<router-view :style="{'height': notShowFooter.includes(routePath)?'auto':'calc(-30% + 100vh) !important',}"></router-view>
		</div>
    </transition>
	<div class="footCss" v-if="!notShowFooter.includes(routePath)"></div> -->
	<transition name="fade" mode="out-in">
		<div :style="backStyle">
			<div :style="scaleStyle">
				<router-view ></router-view>
			</div>
		</div>
    </transition>
	<div class="footCss" v-if="showFooter.includes(routePath) || routePath.includes('/news')"></div>
  </div>
</template>

<script>
import MainHeader from './views/main/components/MainHeader.vue';
export default {
	name: 'app',
	components: {
		MainHeader,
	},
	data() {
		return {
			notShowFooter: ['/login','/main','/systemList','/news','/modifyPassword'],
			showFooter: ['/main','/noticeLists','/systemList','/searchPerson'],
			routePath: '',
			scaleStyle: {
				transform: 'scale(1)',
			},
			backStyle: {
				background: 'linear-gradient(rgb(170, 174, 177), rgb(238, 238, 238))',
				display: 'flex',
				justifyContent: 'center',
				'min-height':'calc( 100vh + 50px)'
			},
			height:1200,
			scale: 1,
		}
	},
	computed: {
		showHeader() {
			console.log(this.$route.path,'this.$route.path')
			this.routePath = this.$route.path
				// 根据当前路径判断是否显示 MainHeader
			// if(this.routePath === '/main' || this.$route.path === '/login'){
			// 	this.updateScale()
			// }
			this.updateScale()
			return this.$route.path !== '/login' && this.$route.path !== '/modifyPassword' && this.$route.path !== '/register'; // '/login'为需要隐藏的路径
		}
	},

	created() {
		this.updateScale();
		// this.$nextTick(()=>{
		// 	this.updateBack();
		// })
		window.addEventListener('resize', this.updateScale);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateScale);
	},
	/**
	 * 
	 */
	methods:{
		updateScale() {
			// // 设计稿基准宽度（如 1920px）
			// const designWidth = 1920;
			// // 当前窗口宽度
			// const windowWidth = window.innerWidth;
			// // 计算缩放比例（限制最小和最大值）
			// const scale = Math.min(
			// 	Math.max(windowWidth / designWidth, 0.1), // 最小缩放 50%
			// 	2.5, // 最大缩放 150%
			// );
			
			// this.scaleStyle = {
			// 	transform: `scale(${scale})`,
			// 	transformOrigin: 'top left',
			// 	width: `${designWidth}px`, // 保持设计稿宽度
			// 	height: '100%',
			// };

			const designWidth = 1240;
			const windowWidth = window.innerWidth;
			const windowHeight = window.innerHeight;

			// 计算宽度比例的缩放
			const scale = Math.min(
				Math.max(windowWidth / designWidth, 0.1), // 最小缩放 10%
				5.5 // 最大缩放 250%
			);
			this.scale = scale
			this.height = windowHeight

			if(this.$route.path === '/login' || this.$route.path === '/noticeLists'){
				this.backStyle = {
					background: 'linear-gradient(rgb(170, 174, 177), rgb(238, 238, 238))',
					display: 'flex',
					justifyContent: 'center',
				}
			}
			console.log(windowWidth,scale,'scale123',windowHeight,this.routePath)
			if(this.$route.path === '/login' || this.$route.path === '/modifyPassword' || this.$route.path === '/main' || this.$route.path === '/noticeLists' || this.$route.path === '/searchPerson' || this.$route.path === '/systemList'  || this.$route.path.includes('/news')){
				this.scaleStyle = {
					transform: `scale(1)`,
					transformOrigin: 'top center',
				}
			}else{
				this.scaleStyle = {
					transform: `scale(${scale})`,
					transformOrigin: 'top center',
					width: '1240px',
				}
			}
			console.log('dsadfjadsuifajsuidfhadsuifahdsuifhausifdhsai',this.scaleStyle)
		},
		updateBack(){
			// this.backStyle.height = window.innerHeight + 'px'
			// if(window.innerHeight < 1210){
			// 	this.backStyle.minWidth = '1210px'
			// }else{
			// 	this.backStyle.width = window.innerWidth + 'px'
			// }
			this.$forceUpdate()
			console.log(document.getElementsByClassName('body-container')[0].style,'updataBack')
		},
	}
}

</script>

<style lang="scss">
.footCss {
    position: absolute;
    bottom: auto;
	left: 0;
	right: 0;
    width: 100%;
    height: 15%;
    box-sizing: border-box;
    background: url('./assets/images/red-footer-background.png') no-repeat;
    background-size: 100% 100%;
	background-color: #eee;
}

html, body {
  width: 100%;
  height: 100%;
	margin: 0px;
	padding: 0px;
	font-family: Microsoft YaHei, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,  SimSun, sans-serif;
	font-size: 12px;
	-webkit-font-smoothing: antialiased;
	// background: #f6f6f6;
}

/* #app {
	// position: absolute;
	// top: 0px;
	// bottom: 0px;
	width: 100%;
  	height: 100%;
} */
a{
  color: #56a9ff;
}
.fade-enter-active,
.fade-leave-active {
	transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue